const baseUrl = 'ws://localhost:7032/'

export default {
  baseUrl: baseUrl
}



// WEBPACK FOOTER //
// ./src/config/wsConf.js